module.exports = __webpack_public_path__ + "static/Sai_Pranav_P-8a923a2606bb84afd629abe36f32d00b.jpeg";